exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-context-tsx": () => import("./../../../src/pages/context.tsx" /* webpackChunkName: "component---src-pages-context-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-transformation-strategy-tsx": () => import("./../../../src/pages/transformation-strategy.tsx" /* webpackChunkName: "component---src-pages-transformation-strategy-tsx" */)
}

